import React, { Component } from "react";
//import {Helmet} from "react-helmet";
import emailjs from 'emailjs-com';

export class Contact extends Component {

  render() {
    
    function sendEmail(e) {
      e.preventDefault();
  
      emailjs.sendForm('service_2e22z6j', 'template_72savhr', e.target, 'user_uCpgSFRnlZFaov0g8MTH5')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        e.target.reset();
    }
    
    return (
      <div>
        {/* <Helmet>
        
        <script type="text/javascript" src="../src/email-js.js"></script>
   
        </Helmet> */}
         
         <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3619.4116646220737!2d67.15483651500337!3d24.883935984042882!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjTCsDUzJzAyLjIiTiA2N8KwMDknMjUuMyJF!5e0!3m2!1sen!2s!4v1607888786114!5m2!1sen!2s" width="100%" height="450" title="Gooogle Map Electroskillsengineering" frameborder="0" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        <div id="contact">
          <div className="container">
            <div className="col-md-8">
              <div className="row">
                <div className="section-title">
                  <h2>Get In Touch</h2>
                  <p>
                    Please fill out the form below to send us an email and we
                    will get back to you as soon as possible.
                  </p>
                </div>
                <form className="contact-form" onSubmit={sendEmail} noValidate>
                <input type="hidden" name="contact_number" />
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="name"
                          className="form-control"
                          placeholder="Name"
                          required="required"
                          name="user_name"
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          id="email"
                          className="form-control"
                          placeholder="Email"
                          required="required"
                          name="user_email"
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      placeholder="Message"
                      required
                    ></textarea>
                    <p className="help-block text-danger"></p>
                  </div>
                  <div id="success"></div>
                  <button type="submit" className="btn btn-custom btn-lg">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
            <div className="col-md-3 col-md-offset-1 contact-info">
              <div className="contact-item">
                <h3>Contact Info</h3>
                <p>
                  <span>
                    <i className="fa fa-map-marker"></i> Address
                  </span>
                  {this.props.data ? this.props.data.address : "loading"}
                </p>
              </div>
              <div className="contact-item">
                <p>
                  <span>
                    <i className="fa fa-phone"></i> Phone
                  </span>{" "}
                  {this.props.data ? this.props.data.phone : "loading"}
                </p>
              </div>
              <div className="contact-item">
                <p>
                  <span>
                    <i className="fa fa-envelope-o"></i> Email
                  </span>{" "}
                  {this.props.data ? this.props.data.email : "loading"}
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div className="row">
                <div className="social">
                  <ul>
                    <li>
                      <a
                        href={this.props.data ? this.props.data.facebook : "/"}
                      >
                        <i className="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href={this.props.data ? this.props.data.whatsapp : "/"}>
                        <i className="fa fa-whatsapp"></i>
                      </a>
                    </li>
                    <li>
                      <a href={this.props.data ? this.props.data.youtube : "/"}>
                        <i className="fa fa-youtube"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="footer">
          <div className="container text-center">
            <p>
              &copy; 2020 <b>Electroskillsengineering</b> | Develop by <a href="https://omaisahmed.blogspot.com/" target="_blank">Omais Ahmed</a>
  
            </p>
          </div>
        </div>
      </div>
    );
  }
}


export default Contact;
